import { useFormikContext } from 'formik';
import NxPopup from '../nxPopup/NxPopup';
import React, { ReactElement, useState } from 'react'
import NxButton, { NxButtonProps } from './NxButton';
import NxRow, { NxRowPosition } from '../nxRow/NxRow';
import { NxFormikSubmitButton } from './NxFormikSubmitButton';
import { NxButtonVariant } from './NxButtonVariants';

export interface Props extends Omit<NxButtonProps, 'loaded' | 'type'>  {
  description: string
}

const NxFormikConfirmationButton  = (props: Props): ReactElement => {
  const context = useFormikContext();
  const [showPopup, setShowPopup] = useState<boolean>(false);
  return (
    <>
      <NxButton {...props}
                onClick={(): void => setShowPopup(true)}
                loaded={!context.isSubmitting}
                type='button'
                disabled={props.disabled || context.isSubmitting || !context.isValid}>
        {props.children}
      </NxButton>
      <NxPopup header='Confirm'
        open={showPopup}
        description={props.description}>
       <NxRow position={NxRowPosition.END}>
         <NxButton variant={NxButtonVariant.CLOSE}
           onClick={(): void => {
             setShowPopup(false);
           }}>
           No
         </NxButton>
         <NxFormikSubmitButton
            variant={NxButtonVariant.SAVE}
            onClick={(): void => {
              setShowPopup(false);
              context.submitForm();
            }}>
           Yes
         </NxFormikSubmitButton>
       </NxRow>
     </NxPopup>
    </>
  );
}
export default NxFormikConfirmationButton